// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../common.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".tZ0GEYe3x{padding:30px;text-align:center;flex-direction:column;flex:1}.tZ0GEYe3x>div{display:flex;flex-direction:column;justify-content:center;align-items:center}.tZ0GEYe3x ._7Cb6s2l8x{flex:1}.tZ0GEYe3x ._3YHM0yT0x{flex:5}.tZ0GEYe3x ._3Vh2GCZ8x{width:100px;max-height:40%}.tZ0GEYe3x ._5aAHLIvwx{margin:30px;color:#9C9C9C;font-size:18px;white-space:pre-line}.tZ0GEYe3x ._6dRilGonx{color:#303030;font-size:14px;white-space:pre-line}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"incompatible": "tZ0GEYe3x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["centered"] + "",
	"logo": "_7Cb6s2l8x",
	"content": "_3YHM0yT0x",
	"graphic": "_3Vh2GCZ8x",
	"message": "_5aAHLIvwx",
	"instructions": "_6dRilGonx"
};
module.exports = exports;
